import accordion from './components/accordion';
import ajax from './components/ajax';
import dropdown from './components/dropdown';
import modal from './components/modal';
import navDropdown from './components/navDropdown';
import navbar from './components/navbar';
import tabs from './components/tabs';
import pdfStateSelect from './app/pdfStateSelect';
import resourcesFeed from './app/resourcesFeed';
import ytModal from './app/ytModal';
import lawmakersCarousel from './app/lawmakersCarousel';
import quoteCarousel from './app/quoteCarousel';
import flipcards from './app/flipcards';
import tooltips from './app/tooltips';
import marquee from './app/marquee';
import senatePhoneSelect from './app/senatePhoneSelect';
import issueQuoteCarousel from './app/issueQuoteCarousel';
import issueAccordion from './app/issueAccordion';
import issueStateStats from './app/issueStateStats';
import issueStateQuotes from './app/issueStateQuotes';
import issuesDownload from './app/issuesDownload';

accordion();
ajax();
dropdown();
modal();
navDropdown();
navbar();
tabs();

pdfStateSelect();
resourcesFeed();
ytModal();
lawmakersCarousel();
quoteCarousel();
flipcards();
tooltips();
marquee();
senatePhoneSelect();
issueQuoteCarousel();
issueAccordion();
issueStateStats();
issueStateQuotes();
issuesDownload();
